// import slick from 'slick-carousel';
//
$(function () {
    // Accessibility: fix tabindex for hidden slick slides
    function updateSlideTabIndexes(sliderSelector) {
        const $slider = $(sliderSelector);

        $slider.find('.slick-slide').each(function () {
            const isHidden = $(this).attr('aria-hidden') === 'true';
            $(this).find('a').attr('tabindex', isHidden ? -1 : 0);
        });
    }

    // Initialize #offersSlider with accessibility patch
    $("#offersSlider").on('init', function () {
        updateSlideTabIndexes('#offersSlider');
    }).on('afterChange', function () {
        updateSlideTabIndexes('#offersSlider');
    }).slick({
        infinite:       true,
        slidesToShow:   1,
        slidesToScroll: 1,
        arrows:         true,
        dots:           false,
        fade:           true,
        speed:          600,
        autoplay:       true,
        autoplaySpeed:  3000,
    });
//
//     // Standard sliders
//     $("[data-slider]").slick({
//         infinite:       true,
//         slidesToShow:   5,
//         slidesToScroll: 1,
//         arrows:         false,
//         dots:           false,
//         speed:          600,
//         lazyLoad:       'ondemand',
//         responsive:     [
//             { breakpoint: 1500, settings: { slidesToShow: 4 } },
//             { breakpoint: 880, settings: { slidesToShow: 3 } },
//             { breakpoint: 750, settings: { slidesToShow: 2 } },
//             { breakpoint: 380, settings: { slidesToShow: 1 } },
//         ]
//     });
//
//     $("[data-category-slider]").slick({
//         infinite:       true,
//         slidesToShow:   3,
//         slidesToScroll: 1,
//         arrows:         false,
//         dots:           false,
//         speed:          600,
//         lazyLoad:       'ondemand',
//         responsive:     [
//             { breakpoint: 750, settings: { slidesToShow: 2 } },
//             { breakpoint: 380, settings: { slidesToShow: 1 } },
//         ]
//     });
//
//     $(".slider__arrows-prev").on("click", function () {
//         const slider = $(this).data('slick-arrows-for');
//         $(slider).slick('slickPrev');
//     });
//
//     $(".slider__arrows-next").on("click", function () {
//         const slider = $(this).data('slick-arrows-for');
//         $(slider).slick('slickNext');
//     });
//
//     // Mobile & Extra sliders with responsive init
//     let mobileSlider = $('[data-mobile-slider]');
//     let mobileSliderBreakpoint = 768;
//
//     let mobileSliderSettings = {
//         initialSlide:   0,
//         slidesToShow:   2,
//         slidesToScroll: 1,
//         infinite:       true,
//         arrows:         false,
//         dots:           true,
//         autoplay:       false,
//         autoplaySpeed:  5000,
//         responsive:     [
//             {
//                 breakpoint: 576,
//                 settings: {
//                     fade: true,
//                     slidesToShow: 1
//                 }
//             }
//         ]
//     };
//
//     let extraSlider = $('[data-extra-slider]');
//     let extraSliderBreakpoint = 768;
//
//     let extraSliderSettings = {
//         initialSlide:   0,
//         slidesToShow:   2,
//         slidesToScroll: 1,
//         infinite:       true,
//         arrows:         false,
//         dots:           false,
//         autoplay:       false,
//         autoplaySpeed:  5000,
//         responsive:     [
//             {
//                 breakpoint: 576,
//                 settings: {
//                     fade: true,
//                     slidesToShow: 1
//                 }
//             }
//         ]
//     };
//
//     function mobSlider(slider, settings, breakpoint) {
//         if (window.innerWidth > breakpoint) {
//             if (slider.hasClass('slick-initialized')) {
//                 slider.slick('unslick');
//             }
//             return;
//         }
//         if (!slider.hasClass('slick-initialized')) {
//             slider.slick(settings);
//         }
//     }
//
//     // Initial responsive sliders
//     mobSlider(mobileSlider, mobileSliderSettings, mobileSliderBreakpoint);
//     mobSlider(extraSlider, extraSliderSettings, extraSliderBreakpoint);
//
//     // Reinit on resize
//     let doit;
//     function resizeWindow() {
//         mobSlider(mobileSlider, mobileSliderSettings, mobileSliderBreakpoint);
//         mobSlider(extraSlider, extraSliderSettings, extraSliderBreakpoint);
//     }
//
//     window.onresize = function () {
//         clearTimeout(doit);
//         doit = setTimeout(resizeWindow, 100);
//     };
});
